import React from "react";
import { PageMeta } from "../components/SiteChrome";

const cvPath = "/docs/ClementGirault-CV-2026.pdf";

export default function CvPage() {
  return (
    <>
      <PageMeta
        title="CV"
        description="Curriculum vitae for Clément Girault, digital strategist, service designer and technology leader."
      />
      <section className="cv-viewer">
        <div className="cv-viewer-toolbar">
          <div>
            <span className="eyebrow">Curriculum vitae</span>
            <h1>Clément Girault</h1>
          </div>
          <a href={cvPath} download>
            Download PDF <span aria-hidden="true">↓</span>
          </a>
        </div>
        <iframe
          className="cv-frame"
          src={`${cvPath}#view=FitH`}
          title="Clément Girault curriculum vitae"
        />
      </section>
    </>
  );
}
